import "bootstrap/dist/css/bootstrap.min.css"
import "./assets/icomoon/style.css"
import "./index.css"
import "./scss/index.scss"

import * as serviceWorker from "./serviceWorker"

import { Provider } from "react-redux"
import React from "react"
import ReactDOM from "react-dom"
import Routes from "./Routes"
import { store } from "./config/store"

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
